/** Detección de tipo para vista previa (repositorio / bóveda). */

export function detectMimeFromName(name: string): string {
  const lower = (name || '').toLowerCase();
  if (lower.endsWith('.pdf')) return 'application/pdf';
  if (lower.endsWith('.png')) return 'image/png';
  if (lower.endsWith('.jpg') || lower.endsWith('.jpeg')) return 'image/jpeg';
  if (lower.endsWith('.gif')) return 'image/gif';
  if (lower.endsWith('.webp')) return 'image/webp';
  if (lower.endsWith('.bmp')) return 'image/bmp';
  if (lower.endsWith('.tif') || lower.endsWith('.tiff')) return 'image/tiff';
  if (lower.endsWith('.svg')) return 'image/svg+xml';
  if (lower.endsWith('.json')) return 'application/json';
  if (lower.match(/\.(xsd|xsl|xslt)$/)) return 'application/xml';
  if (lower.match(/\.(txt|log|csv|xml|md)$/)) return 'text/plain';
  if (lower.match(/\.(doc|docx|docm|dotm)$/)) {
    return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
  }
  if (lower.match(/\.(xlsm|xltm|xlam)$/)) {
    return 'application/vnd.ms-excel.sheet.macroEnabled.12';
  }
  if (lower.match(/\.(xlsb|xls|xlsx|xltx)$/)) {
    return 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }
  if (lower.match(/\.(ppt|pptx|pptm|potm|ppsm|ppam)$/)) {
    return 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
  }
  return 'application/octet-stream';
}

export function isOfficeMime(mime: string, name: string): boolean {
  const lower = name.toLowerCase();
  const m = (mime || '').toLowerCase();
  return (
    m.includes('officedocument') ||
    m.includes('msword') ||
    m.includes('ms-excel') ||
    m.includes('msexcel') ||
    m.includes('ms-powerpoint') ||
    m.includes('macroenabled') ||
    m.includes('spreadsheetml') ||
    m.includes('wordprocessingml') ||
    m.includes('presentationml') ||
    /(vnd\.ms-excel|vnd\.ms-word|vnd\.ms-powerpoint)/.test(m) ||
    /\.(docm|docx|doc|dotm|dotx|dot|xlsm|xlsb|xlsx|xls|xltm|xltx|xlt|xlam|pptm|pptx|ppt|potm|potx|ppam|ppsm|ppsx|pot)$/i.test(
      lower,
    )
  );
}

export function isPdfMime(mime: string, name: string): boolean {
  return mime.includes('pdf') || name.toLowerCase().endsWith('.pdf');
}

/**
 * Contenido legible en `<pre>`. Cuidado: `openxml` y similares contienen la subcadena `xml` → no tratar Office como XML.
 */
export function isTextLikeMime(mime: string, name: string): boolean {
  const lower = name.toLowerCase();
  const m = (mime || '').toLowerCase();
  if (m.startsWith('image/') || m.startsWith('video/') || m.startsWith('audio/')) {
    return false;
  }
  const ooxml =
    m.includes('openxmlformats') || m.includes('officedocument') || m.includes('macroenabled');
  if (ooxml) {
    return false;
  }
  const hasXmlInMime = m.includes('xml') && !ooxml;
  return (
    m.startsWith('text/') ||
    m === 'application/xml' ||
    m === 'text/xml' ||
    m === 'application/xml-dtd' ||
    m.includes('json') ||
    hasXmlInMime ||
    m.includes('xslt') ||
    m.includes('javascript') ||
    m.includes('ecmascript') ||
    m.includes('yaml') ||
    m.includes('x-www-form-urlencoded') ||
    /\+xml$/.test(m) ||
    /\.(txt|log|json|csv|xml|xsd|xsl|xslt|md|yml|yaml|ini|sh|env|http|rest)$/i.test(lower)
  );
}
